import { Component, OnInit } from '@angular/core'
import { CommonModule } from '@angular/common'
import {
  FormArray,
  FormsModule,
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MasterCommonServices } from '../../quotation/master.common.service'
import { MasterDatabaseDisplayModel } from '../../../shared/master-database-display.model'
import { MasterAddUpdateDialogComponent } from '../../../shared/components/master-add-update-dialog/master-add-update-dialog.component'
import { MatDialog } from '@angular/material/dialog'
import { UnitService } from '../../masters/unit.master/unit.service'
import { ToastrService } from 'ngx-toastr'
import { WorkOrderService } from '../workOrder.service'
import { Router } from '@angular/router'
import { MatInputModule } from '@angular/material/input'
import { MatOptionModule } from '@angular/material/core'
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { PartNumberService } from '../../masters/partNumber.master/partNumber.service'
import { startWith } from 'rxjs/operators'
import { PartNumberModel } from '../../masters/partNumber.master/partNumber.model'
import { ConfirmAddPartDialogComponent } from './confirm-add-part-dialog.component/confirm-add-part-dialog.component.component'

@Component({
  selector: 'app-create-work-order',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatAutocompleteModule,
    MatInputModule,
    MatOptionModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatAutocompleteModule,
    MatInputModule,
    MatOptionModule,
  ],
  templateUrl: './createWorkOrder.component.html',
  styleUrls: ['./createWorkOrder.component.css'],
})
export class CreateWorkOrderComponent {
  title: string = 'Add New Work Order'
  workOrderForm!: FormGroup
  submitted: boolean = false
  mode: 'add' | 'update' = 'add' // Ensure mode is defined
  workOrderData: any // To store edit data if needed
  filteredPartNumbers: any[][] = []
  partInputText: string[] = []
  unitColumns: MasterDatabaseDisplayModel[] = [
    {
      key: 'unitName',
      displayName: 'Unit Name',
      hiddenDataTable: false,
      hiddenDialog: false,
      type: 'text',
    },
    {
      key: 'id',
      displayName: 'Id',
      hiddenDataTable: true,
      hiddenDialog: true,
      type: 'text',
    },
  ]

  constructor(
    public masterCommonServices: MasterCommonServices,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private unitService: UnitService,
    private toastr: ToastrService,
    private workOrderService: WorkOrderService,
    private router: Router,
    private partNumberService: PartNumberService,
  ) {
    this.initializeForm()
    if (this.masterCommonServices.unitsList.length === 0) {
      this.masterCommonServices.getAllUnits()
    }
    if (this.masterCommonServices.clientsList.length === 0) {
      this.masterCommonServices.getAllClients()
    }
    if (this.masterCommonServices.partNumberList.length === 0) {
      this.masterCommonServices.getAllPartNumbers()
    }
    const navigation = this.router.getCurrentNavigation()
    if (navigation?.extras.state) {
      const params = navigation.extras.state

      this.mode = params['mode'] || 'add'
      if (this.mode !== 'add') {
        this.workOrderData = {
          workOrderFields: JSON.parse(params['workOrderFields']),
          workOrderItems: JSON.parse(params['workOrderItems']),
        }
        

        this.populateForm(this.workOrderData)
        this.title = 'Update Work Order'
      }
    }
  }
  initializeForm(): void {
    this.workOrderForm = this.fb.group({
      id: [{ value: null, disabled: true }],
      workOrderId: [{ value: null, disabled: true }],
      remarks: [null],
      poNumber: [null],
      workOrderCompanyId: [null, Validators.required],
      workOrderDate: [new Date().toISOString().split('T')[0]],
      addedOn:[null],
      modifiedOn:[null],
      addedBy:[null],
      modifiedBy:[null],
      workItems: this.fb.array([]),
    })
  }
  ngAfterViewInit(): void {
    setTimeout(() => this.resizeAllTextareas())
  }

  resizeAllTextareas(): void {
    const textareas = document.querySelectorAll('textarea.auto-resize')
    textareas.forEach((textarea: any) => {
      textarea.style.height = 'auto'
      textarea.style.height = `${textarea.scrollHeight}px`
    })
  }

  autoResize(event: any) {
    event.target.style.height = 'auto'
    event.target.style.height = event.target.scrollHeight + 'px'
  }

  populateForm(data: any): void {
    this.workOrderForm?.get('id')?.setValue(data.workOrderFields.id)
    this.workOrderForm
      ?.get('workOrderId')
      ?.setValue(data.workOrderFields.workOrderId)
    this.workOrderForm
      ?.get('workOrderDate')
      ?.setValue(data.workOrderFields.workOrderDate.split('T')[0])
    this.workOrderForm
      ?.get('workOrderCompanyId')
      ?.setValue(data.workOrderFields.workOrderCompanyId)
    this.workOrderForm
      ?.get('poNumber')
      ?.setValue(data.workOrderFields.purchaseOrderNumber)
    this.workOrderForm?.get('remarks')?.setValue(data.workOrderFields.remarks)
    this.workOrderForm?.get('addedOn')?.setValue(data.workOrderFields.addedOn)
    this.workOrderForm?.get('modifiedOn')?.setValue(data.workOrderFields.modifiedOn)
    this.workOrderForm?.get('addedBy')?.setValue(data.workOrderFields.addedBy)
    this.workOrderForm?.get('modifiedBy')?.setValue(data.workOrderFields.modifiedBy)
    if (data.workOrderItems?.length > 0) {
      this.workItems?.clear()
      
      data.workOrderItems.forEach((item: any) => {
        const itemGroup = this.fb.group({
          id: [item.id],
          srNo: [item.srNo],
          partNumberId: [item.partNumberId],
          description: [item.description],
          quantity: [item.quantity],
          dispatchedQuantity: [item.dispatchedQuantity],
          unit: [item.unit],
          isDeleted: [item.isDeleted],
        })
        this.workItems?.push(itemGroup)
      })
    }
  }

  get workItems(): FormArray {
    return this.workOrderForm.get('workItems') as FormArray
  }

  addRow(): void {
    this.workOrderForm.markAsDirty()
    const itemGroup = this.fb.group({
      srNo: [null],
      partNumberId: [null],
      description: [''],
      quantity: [0, Validators.required],
      dispatchedQuantity: [0],
      unit: [null],
      isDeleted: [false],
    })

    const index = this.workItems.length
    this.filteredPartNumbers[index] = this.masterCommonServices.partNumberList

    itemGroup
      .get('partNumberId')
      ?.valueChanges.pipe(startWith(''))
      .subscribe((value) => {
        const filterValue = value?.toString().toLowerCase() || ''
        this.filteredPartNumbers[
          index
        ] = this.masterCommonServices.partNumberList.filter((part) =>
          part.partName.toLowerCase().includes(filterValue),
        )
      })

    this.workItems.push(itemGroup)
  }

  getPartNameById(id: number | null): string {
    return (
      this.masterCommonServices.partNumberList.find((p) => p.id === id)
        ?.partName || ''
    )
  }

  onPartNumberInput(value: string, index: number): void {
    this.workOrderForm.markAsDirty()
    this.partInputText[index] = value
    const filterValue = value?.toLowerCase() || ''
    this.filteredPartNumbers[
      index
    ] = this.masterCommonServices.partNumberList.filter((part) =>
      part.partName.toLowerCase().includes(filterValue),
    )
  }

  onPartNumberSelected(selectedName: string, index: number): void {
    this.workOrderForm.markAsDirty()
    const selectedPart = this.masterCommonServices.partNumberList.find(
      (p) => p.partName === selectedName,
    )
    if (selectedPart) {
      const group = this.workItems.at(index) as FormGroup
      group.patchValue({
        partNumberId: selectedPart.id,
        description: selectedPart.description || '',
      })
    }
  }

  onPartNumberFocus(index: number): void {
    // Show full list when input is focused
    this.filteredPartNumbers[index] = this.masterCommonServices.partNumberList
  }
  onPartNumberBlur(index: number): void {
    const input = this.partInputText[index]?.trim()
    if (!input) return

    const group = this.workItems.at(index) as FormGroup
    const existing = this.masterCommonServices.partNumberList.find(
      (p) => p.partName.toLowerCase() === input.toLowerCase(),
    )

    if (existing) {
      group.patchValue({
        partNumberId: existing.id,
        description: existing.description || '',
      })
      return
    }

    const dialogRef = this.dialog.open(ConfirmAddPartDialogComponent, {
      width: '400px',
      data: { input },
    })
    dialogRef
      .afterClosed()
      .subscribe((result: { proceed: boolean; description?: string }) => {
        if (!result?.proceed) return

        const now = new Date().toISOString()
        const newPart: PartNumberModel = {
          id: 0,
          partName: input,
          description: result.description || '',
          addedOn: now,
          modifiedOn: now,
          isDeleted: false,
        }

        this.partNumberService.addPartNumber(newPart).subscribe({
          next: () => {
            this.toastr.success('New Part Number Added!', 'Success')
            this.partNumberService.getAllPartNumbers().subscribe((list) => {
              this.masterCommonServices.partNumberList = list
              const added = list.find(
                (p) => p.partName.toLowerCase() === input.toLowerCase(),
              )
              if (added) {
                group.patchValue({
                  partNumberId: added.id,
                  description: added.description || '',
                })
              }
            })
          },
          error: (err) => {
            this.toastr.error(
              err.statusText || 'Failed to add part number',
              'Error',
            )
          },
        })
      })
  }

  removeRow(index: number): void {
    this.workOrderForm.markAsDirty()
    const formGroup = this.workItems.at(index) as FormGroup
    formGroup.patchValue({ isDeleted: true })

    Object.keys(formGroup.controls).forEach((key) => {
      formGroup.get(key)?.clearValidators()
      formGroup.get(key)?.updateValueAndValidity()
    })
  }

  hasVisibleRows(): boolean {
    return this.workItems.controls.some((item) => !item.get('isDeleted')?.value)
  }

  openAddUpdateUnitDialog(): void {
    const dialogRef = this.dialog.open(MasterAddUpdateDialogComponent, {
      data: {
        item: {},
        mode: 'add',
        fields: this.unitColumns,
      },
    })

    dialogRef.afterClosed().subscribe((result) => {
      if (result) this.addUnit(result)
    })
  }

  addUnit(unit: any): void {
    this.unitService.addUnit(unit).subscribe({
      next: () => {
        this.toastr.success('Unit Added Successfully!', 'Success')
        this.unitService.getAllUnits().subscribe({
          next: (data) => {
            this.masterCommonServices.unitsList = data
          },
          error: (error) => {
            this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
          },
        })
      },
      error: (error) => {
        this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
      },
    })
  }

  submit(): void {
    this.submitted = true
    

    if (this.workOrderForm.invalid && this.hasVisibleRows()) {
      this.toastr.error('Please fill all required fields', 'Error')
      return
    }

    if (!this.hasVisibleRows()) {
      this.toastr.error('Please add at least one item', 'Error')
      return
    }
   
    const raw = this.workOrderForm.getRawValue()
    const processedData = this.processFormData(raw)

    if (this.mode === 'add' && this.workOrderForm.get('workOrderId')?.value === null) {
      this.workOrderService.addWorkOrder(processedData).subscribe({
        next: (data: any) => {
          if(data.id){
            this.workOrderService.getWorkOrderById(data.id).subscribe({
            next: (wo) => {
              this.populateForm(wo)
            },
            error: (error) => {
              this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
            },
          })
          }
          this.workOrderForm.markAsPristine();
          this.title = 'Update Work Order'
          this.toastr.success('Work Order Added Successfully!', 'Success')
        },
        error: (error: any) => {
          this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
        },
      })
    } else {
      this.workOrderService.updateWorkOrder(processedData).subscribe({
        next: (data: any) => {
          if(data.id){
            this.workOrderService.getWorkOrderById(data.id).subscribe({
            next: (wo) => {
              this.populateForm(wo)
            },
            error: (error) => {
              this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
            },
          })
          }
          this.workOrderForm.markAsPristine();
          this.toastr.success('Work Order Updated Successfully!', 'Success')
        },
        error: (error: any) => {
          this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
        },
      })
    }
  }

  processFormData(data: any): any {
    const now = new Date(
      new Date().getTime() - new Date().getTimezoneOffset() * 60000,
    ).toISOString()
    const workOrderFields = {
      id: data.id,
      workOrderId: data.workOrderId,
      workOrderCompanyId: data.workOrderCompanyId,
      purchaseOrderNumber: data.poNumber,
      remarks: data.remarks,
      workOrderDate: data.workOrderDate,
      addedOn:
        this.mode === 'add'
          ? now
          : this.workOrderData?.workOrderFields?.addedOn || now,
      addedBy: this.workOrderData?.workOrderFields?.addedBy,    
      modifiedOn: now,
    }

    const workOrderItems = data.workItems
      .filter((item: any) => this.mode === 'update' || !item.isDeleted)
      .map((item: any, index: number) => {
        // item.workOrderId = workOrderFields.workOrderId
        item.addedOn = now
        item.modifiedOn = now
        this.processFields(item)
        return item
      })

    return {
      workOrderFields,
      workOrderItems,
    }
  }

  processFields(fields: any): void {
    for (const key in fields) {
      if (fields.hasOwnProperty(key)) {
        const value = fields[key]
        if (value === null || value === undefined) {
          if (this.isNumericField(key)) {
            fields[key] = 0
          }
        }
      }
    }
  }

  isNumericField(key: string): boolean {
    const numericFields = ['quantity', 'dispatchedQuantity']
    return numericFields.includes(key)
  }
}
